export default {
  // 模式
  "common.mode.auto": "โหมดใช้พลังงานที่ผลิตเองด้วยตนเอง",
  "common.mode.economy": "โหมดเศรษฐกิจ",
  "common.mode.exigency": "โหมดฉุกเฉิน",

  // 设备
  "common.grid": "เครือข่ายไฟฟ้า",
  "common.evChargers": "เครื่องชาร์จรถไฟฟ้า",
  "common.evCharger": "เครื่องชาร์จรถไฟฟ้า",
  "common.pv": "พลังงานแสงแดด (PV)",
  "common.inverter": "อินเวอร์เตอร์",
  "common.pcs": "อินเวอร์เตอร์ + แบตเตอรี่",
  "common.terminal": "อุปกรณ์เทอร์มินัล",
  "common.airc": "เครื่องปรับอากาศ",
  "common.engine": "เครื่องยนต์",
  "common.battery": "แบตเตอรี่",
  "common.metter": "มิเตอร์ไฟฟ้า",
  "common.other": "อื่น ๆ",
  "common.power": "กำลังไฟ",
  "common.powerTotal": "กำลังไฟทั้งหมด",
  "common.voltage": "แรงดันไฟฟ้า",
  "common.electricity": "พลังงานไฟฟ้า",
  "common.current": "กระแสไฟฟ้า",
  "common.homeUsage": "โหลดทั้งหมดของบ้าน",
  "common.battery.power": "กำลังไฟของแบตเตอรี่",

  // 数据
  "common.noDataAvailable": "ไม่มีข้อมูลในขณะนี้~",
  "common.tips": "คำแนะนำ",
  "common.reset": "รีเซ็ต",
  "common.currencyUnit": "¥",
  "common.submiting": "กำลังส่ง... โปรดรอ...",
  "common.close": "ปิด",
  "common.from": "จาก",
  "common.useIn": "ใช้สำหรับ",
  "common.energyPercent": "เปอร์เซ็นต์การไหลของพลังงาน",
  "common.dataFlow": "การไหลของข้อมูล",
  "common.getDataIng": "กำลังรับข้อมูล... โปรดรอ...",
  "common.pageLoading": "กำลังโหลดเนื้อหาหน้า... โปรดรอ...",
  "common.reseting": "กำลังรีเซ็ตเนื้อหาหน้า... โปรดรอ...",
  "common.save": "บันทึก",
  "common.onlyNumberTips": "สามารถป้อนตัวเลขเท่านั้น",
  "common.offline": "ออฟไลน์",
  "common.online": "ออนไลน์",
  "common.fault": "ข้อผิดพลาด",
  "common.charge": "ชาร์จ",
  "common.discharge": "ปล่อยพลังงาน (การสูญเสีย)",
  "common.buy": "ซื้อ",
  "common.sell": "ขาย",
  "common.loadingInfo": "กำลังโหลด... โปรดรอ...",

  // 
  "common.moreFeatures": "คุณสมบัติเพิ่มเติม",
  "common.confirm": "ยืนยัน",
  "common.saveing": "กำลังบันทึก... โปรดรอ...",
  "common.searchPlacholder": "ป้อนคำค้นหา",
  "common.iSee": "ฉันเข้าใจแล้ว",
  "common.pageErrorTips1": "โอ้ มีข้อผิดพลาดเกิดขึ้นบนหน้า~",
  "common.pageErrorTips2": "ลองรีเฟรชหน้าหรือติดต่อฝ่ายสนับสนุน~",
  "common.refresh": "รีเฟรช",
  "common.backToHome": "กลับไปหน้าแรก",
  "common.checkTips": "กำลังตรวจสอบ... โปรดรอ...",
  "common.back": "กลับ",
  "common.cancel": "ยกเลิก",
  "common.optional": "ตัวเลือก",
  "common.required": "จำเป็น",
  "common.status": "สถานะ",
  "common.statusNoDelete": "ยังไม่ลบ",
  "common.statusDelete": "ลบแล้ว",
  "common.submit": "ส่ง",
  "common.disable": "ปิดการใช้งาน",
  "common.enable": "เปิดการใช้งาน",
  "common.year": "ปี",
  "common.month": "เดือน",
  "common.day": "วัน",
  "common.version": "เวอร์ชัน:",
  "common.backHome": " กลับไปหน้าแรก",
  "common.backHomeSorry": " ขอโทษ หน้าเสียหลงทางโดยไม่ได้ตั้งใจ",
  "common.requestTips1": "กำลังประมวลผลข้อมูล โปรดอย่า ส่งซ้ำ",
  "common.requestTips2": "แจ้งเตือนระบบ",
  "common.requestTips3": "สถานะการเข้าสู่ระบบหมดอายุ โปรดเข้าสู่ระบบอีกครั้ง",
  "common.requestTips4": "เข้าสู่ระบบอีกครั้ง",
  "common.requestTips5": "เซสชันไม่ถูกต้องหรือหมดอายุ โปรดเข้าสู่ระบบอีกครั้ง",
  "common.requestTips6": "เซิร์ฟเวอร์มีข้อผิดพลาด โปรดลองอีกครั้งในภายหลัง",
  "common.requestTips7": "เวลาในการร้องขออินเทอร์เฟซระบบหมดแล้ว",
  "common.requestTips8": "อินเทอร์เฟซระบบ",
  "common.requestTips9": "ข้อผิดพลาด",
  "common.iknow": "ฉันเข้าใจแล้ว",
  "common.logoutSuccess": "ออกจากระบบสำเร็จ",
  
  // 了解更多组件
  "common.knowMore.title": "สำหรับข้อมูลเพิ่มเติม โปรดติดต่อ Beineng",
  "common.knowMore.email": "อีเมลติดต่อ",
  "common.knowMore.phone": "เบอร์โทรศัพท์ติดต่อ",
  "common.knowMore.wechat": "WeChat ติดต่อ",
  "common.knowMore.website": "ที่อยู่เว็บไซต์ الرسمي",
  "common.knowMore.address": "ที่อยู่ติดต่อ",
  "common.knowMore.addressDetail": "ห้อง 1205, 1301 อาคาร 5 ถนนชิงเหอที่ 8 หมู่บ้านหว่างจิ่งแคง ตำบลหว่างจิ่งแคง อำเภอหว่างกลาง จังหวัดตงกวน มณฑลกวงดง",
  
  // 本地连接组件
  "common.localConnection": "การเชื่อมต่อโลคัล",
  "common.operateInApp": "ดำเนินการในแอปพลิเคชัน!",
  
  "common.enbleStaus": "สถานะการเปิดใช้งาน",
  "common.battery.status": "ไม่ชาร์จและไม่ปล่อยพลังงาน",

  "account.forgetThePassword": "ลืมรหัสผ่าน",
  "account.logInDirectly": "เข้าสู่ระบบโดยตรง",
  "account.tips1": "กำลังเปลี่ยนเส้นทางไปหน้า... โปรดรอ...",
  "account.tips2": "ขอแนะนำให้อ่านและยอมรับเงื่อนไขการใช้งานก่อน!",
  "account.autoLogin": "เข้าสู่ระบบอัตโนมัติ",
  "account.userLogin": "เข้าสู่ระบบผู้ใช้",
  "account.registerTips": "ยังไม่มีบัญชี? คลิกที่นี่เพื่อสมัคร",
  "account.userEmail": "ชื่อผู้ใช้ / อีเมล",
  "account.userEmailTips": "ป้อนชื่อผู้ใช้หรืออีเมล",
  "account.password": "รหัสผ่าน",
  "account.passwordTips": "ป้อนรหัสผ่าน",
  "account.submit": "ส่ง",
  "account.submitTips": "กำลังส่ง... โปรดรอ...",
  "account.otherLoginTips": "หรือเลือกวิธีเข้าสู่ระบบอื่น",
  "account.userRegistration": "สมัครสมาชิกผู้ใช้",
  "account.userName": "ชื่อผู้ใช้",
  "account.userNameTips": "ป้อนชื่อผู้ใช้",
  "account.emailTips1": "ป้อนที่อยู่อีเมล",
  "account.emailTips2": "รูปแบบอีเมลไม่ถูกต้อง",
  "account.phone": "เบอร์โทรศัพท์",
  "account.phoneTips1": "ป้อนเบอร์โทรศัพท์",
  "account.phoneTips2": "เบอร์โทรศัพท์ไม่ถูกต้อง",
  "account.phoneTips3": "ป้อนเบอร์โทรศัพท์",
  "account.passwordTips1": "ป้อนรหัสผ่าน (6-30 ตัวอักษร)",
  "account.passwordTips2": "รูปแบบรหัสผ่านไม่ถูกต้อง: รหัสผ่านต้องประกอบด้วยตัวอักษรภาษาอังกฤษ ตัวเลข ขีดล่าง ขีด横线 และจุด ความยาว 6-12 ตัวอักษร",
  "account.passwordTips3": "รหัสผ่านที่ป้อนสองครั้งไม่ตรงกัน โปรดตรวจสอบและป้อนอีกครั้ง!",
  "account.passwordTips4": "ป้อนรหัสผ่าน: รหัสผ่านต้องประกอบด้วยตัวอักษรภาษาอังกฤษ ตัวเลข ขีดล่าง ขีด横线 และจุด",
  "account.passwordTips5": "ยืนยันรหัสผ่าน",
  "account.passwordTips6": "ป้อนการยืนยันรหัสผ่าน",
  "account.passwordTips7": "รหัสผ่านที่ป้อนสองครั้งไม่ตรงกัน โปรดตรวจสอบและป้อนอีกครั้ง!",
  "account.passwordTips8": "ป้อนการยืนยันรหัสผ่าน",
  "account.passwordTips9": "ยินดีด้วย สมัครสมาชิกสำเร็จ!",
  "account.passwordTips10": "ชื่อผู้ใช้ของคุณคือ:",
  "account.emailIs": "อีเมลคือ:",
  "account.goToLoginPage": "จะเปลี่ยนเส้นทางไปหน้าเข้าสู่ระบบอัตโนมัติหลังจาก s วินาที",
  "account.goLogin": "เข้าสู่ระบบ",
  "account.goRegister": "สมัครสมาชิก",
  "account.loginSuccess": "เข้าสู่ระบบสำเร็จ",
  "account.email": "อีเมล",
  "account.sologn": "เราได้สร้างแผนพลังงานที่ปรับแต่งให้เหมาะกับคุณอย่างรอบคอบ",
  "account.pleaseAgree": "ฉันได้อ่านและยอมรับ",
  "userAgreement.privacyPolicy": "นโยบายความเป็นส่วนตัว",

  "account.code": "รหัสยืนยัน",
  "account.codeTips": "ป้อนรหัสยืนยัน",
  "account.codeTips2": "รหัสยืนยันไม่ถูกต้อง",

    "account.inviteCodeTips": "กรุณากรอกรหัสเชิญ",
    "account.inviteCodeHint": "กรุณาติดต่อช่างติดตั้งหรือเจ้าหน้าที่ดูแลระบบเพื่อรับรหัสเชิญ",
  "account.modifyPasswordByAccount": "เปลี่ยนรหัสผ่านผ่านบัญชี",
  "account.modifyPasswordByEmail": "เปลี่ยนรหัสผ่านผ่านอีเมล",
  "account.getPasswordByAccount": "รับรหัสผ่านผ่านบัญชี",
  "account.getPasswordByEmail": "รับรหัสผ่านผ่านอีเมล",

  "account.sendEmailTips": "รหัสยืนยัน已ส่ง至อีเมล โปรดตรวจสอบ",
  "account.name": "ชื่อบัญชี",
  "account.newPassword": "รหัสผ่านใหม่",
  "account.confirmNewPassword": "ยืนยันรหัสผ่านใหม่",
  "account.nameTips": "ป้อนชื่อบัญชี",
  "account.passwordModifySuccess": "เปลี่ยนรหัสผ่านสำเร็จ",
  "account.emailCode": "รหัสยืนยันอีเมล",
  "account.emailCodeTips": "ป้อนรหัสยืนยันอีเมล",
  "account.emailCodeTips2": "รหัสยืนยันอีเมลไม่ถูกต้อง",
  "account.emailModifySuccess": "เปลี่ยนรหัสผ่านสำเร็จ",
  "account.passworTips1": "รหัสผ่านของคุณ已รีเซ็ตสำเร็จ!",
  "account.passwordTips11": "ป้อนการยืนยันรหัสผ่าน",
  "account.passwordTips12": "ป้อนรหัสผ่านใหม่",
  "account.nickname": "ชื่อเล่นผู้ใช้",
  "account.modifyNickname": "เปลี่ยนชื่อเล่นผู้ใช้",
  "account.modifyNicknameSuccess": "เปลี่ยนชื่อเล่นผู้ใช้สำเร็จ!",
  "account.nicknameTips": "ป้อนชื่อเล่นผู้ใช้",
  "account.nicknameError": "เปลี่ยนชื่อเล่นผู้ใช้ไม่สำเร็จ!",

  "account.login": "เข้าสู่ระบบ",
  "account.quickRegister": "สมัครสมาชิกแบบรวดเร็ว",
  "account.sendCode": "ส่งรหัสยืนยัน",
  "account.sendTips": "สามารถส่งอีกครั้งหลังจาก s วินาที",
  "account.sendEmailIng": "กำลังส่งอีเมล... โปรดรอ...",
  "account.emailNotEmpty": "ที่อยู่อีเมลไม่สามารถเว้นว่างได้",
  "account.registerAccount": "สมัครบัญชี",
  "account.registerWelcome": "ยินดีต้อนรับสู่การสมัครสมาชิก SusprSafe",
  "account.usernameLimit": "ชื่อผู้ใช้ต้องเริ่มต้นด้วยตัวอักษรและสามารถประกอบด้วยตัวอักษร ตัวเลข และขีดล่างเท่านั้น ความยาว 5-15 ตัวอักษร",

  "copyright.desc2": "ข้อมูลการลงทะเบียนเว็บไซต์: การลงทะเบียน ICP จังหวัดกวงดง เลขที่ 2021169764",

  "editUserInfo.editUserInformation": "แก้ไขข้อมูลผู้ใช้",
  "editUserInfo.modifyUsername": "เปลี่ยนชื่อผู้ใช้",
  "editUserInfo.changePictures": "เปลี่ยนรูปโปรไฟล์",
  "editUserInfo.savePicturesSuccess": "บันทึกรูปโปรไฟล์ผู้ใช้สำเร็จ",
  "editUserInfo.saveError": "บันทึกไม่สำเร็จ",
  "editUserInfo.pictureLimit": "ขนาดรูปภาพต้อง小于 2 MB",
  "editUserInfo.uploadPicture": "อัปโหลดรูปโปรไฟล์",
  "editUserInfo.picturePreview": "ดูตัวอย่าง",
  
  "editUserInfo.bindPhoneNumber": "เชื่อมโยงเบอร์โทรศัพท์",
  "editUserInfo.bindEmail": "เชื่อมโยงอีเมล",
  "editUserInfo.changePassword": "เปลี่ยนรหัสผ่าน",

  "editUserInfo.notificationSettings": "ตั้งค่าการแจ้งเตือน",
  "editUserInfo.editAccount": "แก้ไขข้อมูลบัญชีผู้ใช้",
  "editUserInfo.waitBingting": "กำลังเชื่อมโยง... โปรดรอ...",
  "editUserInfo.collapse": "ย่อขนาด",
  "editUserInfo.modifyBinding": "แก้ไขการเชื่อมโยง",
  
  "editUserInfo.emailAddress": "ที่อยู่อีเมล",
  "editUserInfo.tips1": "เชื่อมโยงอีเมลสำเร็จ",
  "editUserInfo.tips2": "บันทึกไม่สำเร็จ",
  "editUserInfo.tips3": "กำลังส่งรหัสยืนยันอีเมล... โปรดรอ...",
  "editUserInfo.tips4": "รหัสยืนยัน已ส่ง至อีเมล xxxx โปรดตรวจสอบ",
  "editUserInfo.tips5": "ส่งรหัสยืนยันไม่สำเร็จ!",
  "editUserInfo.tips6": "เบอร์โทรศัพท์已เชื่อมโยงแล้ว",
  "editUserInfo.tips7": "อีเมล已เชื่อมโยงแล้ว",
  "editUserInfo.emailTips1": "ป้อนที่อยู่อีเมล",
  "editUserInfo.emailTips2": "รูปแบบอีเมลไม่ถูกต้อง",
  "editUserInfo.emailTips3": "สามารถส่งอีกครั้งหลังจาก xxxx วินาที",
  "editUserInfo.emailTips4": "ส่งรหัสยืนยัน",
  "editUserInfo.emailTips5": "รหัสยืนยันอีเมลไม่สามารถเว้นว่างได้",
  "editUserInfo.emailTips6": "รหัสยืนยันอีเมลไม่ถูกต้อง",
  "editUserInfo.emailCode": "รหัสยืนยันอีเมล",
  "editUserInfo.save": "บันทึก",

  "editUserInfo.phoneTips1": "เชื่อมโยงเบอร์โทรศัพท์สำเร็จ",
  "editUserInfo.phoneTips2": "กำลังส่งรหัสยืนยัน SMS... โปรดรอ...",
  "editUserInfo.phoneTips3": "รหัสยืนยัน SMS已ส่ง至เบอร์โทรศัพท์ xxxx โปรดตรวจสอบ",
  "editUserInfo.phoneTips4": "ส่งรหัสยืนยัน SMSไม่สำเร็จ!",
  "editUserInfo.phoneTips5": "ป้อนเบอร์โทรศัพท์",
  "editUserInfo.phoneTips6": "รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง",
  "editUserInfo.phoneTips7": "ส่งรหัสยืนยัน SMS",
  "editUserInfo.phoneTips8": "รหัสยืนยัน SMS",
  "editUserInfo.phoneTips9": "รหัสยืนยัน SMSไม่สามารถเว้นว่างได้",
  "editUserInfo.phoneTips10": "รหัสยืนยัน SMSไม่ถูกต้อง",
  "editUserInfo.phone": "เบอร์โทรศัพท์",


  "editUserInfo.noticeTips1": "ดึงข้อมูลตั้งค่าการแจ้งเตือนไม่สำเร็จ!",
  "editUserInfo.noticeTips2": "บันทึกตั้งค่าการแจ้งเตือนสำเร็จ!",
  "editUserInfo.noticeTips3": "แจ้งเตือนระดับแบตเตอรี่ต่ำ",
  "editUserInfo.noticeTips4": "แจ้งเตือนการชาร์จเครื่องชาร์จเสร็จสิ้น",
  "editUserInfo.errorNotification": "แจ้งเตือนข้อผิดพลาด",
  "editUserInfo.updateNotification": "แจ้งเตือนการอัปเดต",
  "editUserInfo.monthlyStatisticsNotification": "แจ้งเตือนสถิติรายเดือน",
  "editUserInfo.notificationMethod": "วิธีรับแจ้งเตือน",

  "editUserInfo.userNameTips1": "บันทึกชื่อผู้ใช้สำเร็จ",
  "editUserInfo.userNameTips2": "บันทึกชื่อผู้ใช้ไม่สำเร็จ",
  "editUserInfo.userNameTips3": "ป้อนชื่อผู้ใช้",
  "editUserInfo.userNameTips4": "รูปแบบชื่อผู้ใช้ไม่ถูกต้อง: ต้องประกอบด้วยตัวเลข ขีดล่าง และตัวอักษรภาษาอังกฤษเท่านั้น",
  "editUserInfo.userNameTips5": "ป้อนชื่อผู้ใช้",
  "editUserInfo.userNameTips6": "กำลังบันทึก... โปรดรอ...",
  "editUserInfo.userName": "ชื่อผู้ใช้",

  "editUserInfo.avatorTips": "คลิกเพื่อเปลี่ยนรูปโปรไฟล์",
  "editUserInfo.verifyCodeTips1": "ป้อนรหัสยืนยันที่ได้รับ:",
  "editUserInfo.verifyCodeTips2": "เพื่อความปลอดภัยของบัญชีของคุณ โปรดคลิกปุ่มด้านล่างเพื่อส่งรหัสยืนยัน至เบอร์โทรศัพท์ต้นฉบับ:",
  "editUserInfo.verifyCodeTips3": "ส่งรหัสยืนยัน",
  "editUserInfo.verifyCodeTips4": "ยืนยันเบอร์โทรศัพท์ต้นฉบับสำเร็จ ป้อนเบอร์โทรศัพท์ที่เชื่อมโยงใหม่",
  "editUserInfo.verifyCodeTips5": "เพื่อความปลอดภัยของบัญชีของคุณ โปรดคลิกปุ่มด้านล่างเพื่อส่งรหัสยืนยัน至อีเมลต้นฉบับ:",
  "editUserInfo.verifyCodeTips6": "ยืนยันอีเมลต้นฉบับสำเร็จ ป้อนอีเมลใหม่",
  "editUserInfo.verifyCodeTips7": "รหัสผ่านเก่า",
  "editUserInfo.verifyCodeTips8": "โปรดเชื่อมโยงอีเมลก่อน!",
  "editUserInfo.verifyCodeTips9": "รหัสยืนยัน已ส่ง至อีเมล โปรดตรวจสอบ",
  "editUserInfo.verifyCodeTips10": "将เปลี่ยนเส้นทางไปหน้าเข้าสู่ระบบอัตโนมัติ",

  "hems.notice.title": "หัวข้อแจ้งเตือน", 
  "hems.notice.content": "เนื้อหาแจ้งเตือน", 
  "hems.notice.operate": "การดำเนินการ",
  "hems.notice.noRead": "ยังไม่อ่าน",
  "hems.notice.read": "อ่านแล้ว",
  "hems.notice.warning": "คำเตือน",
  "hems.notice.error": "ข้อผิดพลาด",
  "hems.notice.success": "การคำนวณสถิติ",
  "hems.notice.sys": "ข้อมูลระบบ",
  "hems.notice.operateSuccess": "การดำเนินการสำเร็จ",
  "hems.notice.operateTips": "เลือกรายการเพื่อดำเนินการ",

  // 首页
  "hems.home.selfuseRate": "อัตราการใช้เอง",
  "hems.home.percent": "เปอร์เซ็นต์",
  "hems.home.todayData": "ข้อมูลวันนี้",
  "hems.home.todayPowerGeneration": "การผลิตพลังงานวันนี้",
  "hems.home.salesIncome": "รายได้จากการขายพลังงาน",
  "hems.home.saved": "คุณประหยัดได้",
  "hems.home.reduce": "ลดรอยเท้าคาร์บอน",
  "hems.home.tips1": "ไม่มีข้อมูลในขณะนี้ คุณยังไม่ได้เชื่อมโยง xxxx",
  "hems.home.criticalLoad": "โหลดวิกฤต",
  "hems.home.keyVoltage": "แรงดันไฟฟ้าวิกฤต",
  "hems.home.householdLoad": "โหลดบ้าน",
  "hems.home.householdVoltage": "แรงดันไฟฟ้าบ้าน",
  "hems.home.generalLoad": "โหลดทั่วไป",
  "hems.home.generalVoltage": "แรงดันไฟฟ้าทั่วไป",
  "hems.home.batteryHealth": "สถานะสุขภาพแบตเตอรี่",
  "hems.home.averageTemp": "อุณหภูมิเฉลี่ย",
  "hems.home.gridLoad": "โหลดเครือข่ายไฟฟ้า",
  "hems.home.toggeleDataSource": "ข้อมูลที่แสดงอยู่ในขณะนี้已เปลี่ยนเป็น:",
  "hems.home.toggleTips": "คุณแน่ใจที่จะเปลี่ยนหรือไม่?",
  "hems.home.modeSending": "กำลังส่งคำสั่งโหมด... โปรดรอ...",
  "hems.home.modeSuccess": "ส่งคำสั่งเปลี่ยนโหมดสำเร็จ!",
  "hems.home.isOnline": "ออนไลน์หรือไม่?",
  "hems.home.useStatus": "สถานะการใช้งาน",
  "hems.home.workModeText": "โหมดทำงานปัจจุบัน:",
  "hems.home.toggleDataSourceText": "ข้อมูลที่แสดงอยู่ในขณะนี้已เปลี่ยนเป็น:",
  "hems.ev.charge.status": "สถานะการชาร์จ",
  "hems.ev.charge.time": "เวลาการชาร์จ",
  "hems.ev.charge.count": "ปริมาณการชาร์จแบบเรียลไทม์",
  "hems.ev.charge.status.empty": "ว่าง",
  "hems.ev.charge.status.ing": "กำลังชาร์จด้วยสายเคเบิลที่เชื่อมโยง",
  "hems.ev.charge.status.null": "สายเคเบิล已เชื่อมโยง แต่ไม่ชาร์จ",
  "hems.ev.charge.status.error": "ข้อผิดพลาด",
  "hems.hour": "ชั่วโมง",
  "hems.minue": "นาที",
  "hems.ev.chagre.number": "หมายเลขเครื่องชาร์จ",

  // User Guide
  "hems.userGuide.selfUse": "ใช้พลังงานที่ผลิตเองด้วยตนเอง",
  "hems.userGuide.selfUseTips": "ใช้พลังงานแสงแดดเป็นอันดับแรก หากไม่พอ ให้เติมจากเครือข่ายไฟฟ้า",
  "hems.userGuide.economyMode": "โหมดเศรษฐกิจ",
  "hems.userGuide.economyModeTips": "ปรับแต่งกลยุทธ์การใช้พลังงานตามราคาพลังงานไฟฟ้า",
  "hems.userGuide.emergencyMode": "โหมดฉุกเฉิน",
  "hems.userGuide.emergencyModeTips": "ให้ความสำคัญกับการให้พลังงานแก่โหลดวิกฤตก่อน",

  // 图表页面
  "hems.history.energyStatistics": "สถิติพลังงาน",
  "hems.history.revenueStatistics": "สถิติรายได้",
  "hems.history.greenStatistics": "ลดการปล่อยก๊าซเขียว",
  "hems.history.revenueTitle": "รายได้ทั้งหมดจากการขายพลังงาน",
  "hems.history.savingsTitle": "ประหยัดทั้งหมด",
  "hems.history.carbonTitle": "ลดคาร์บอนทั้งหมด",
  "hems.history.day": "วัน",
  "hems.history.month": "เดือน",
  "hems.history.year": "ปี",
  "hems.history.beforeDay": "วันก่อนหน้า",
  "hems.history.afterDay": "วันถัดไป",
  "hems.history.beforeMonth": "เดือนก่อนหน้า",
  "hems.history.afterMonth": "เดือนถัดไป",
  "hems.history.beforeYear": "ปีก่อนหน้า",
  "hems.history.afterYear": "ปีถัดไป",
  "hems.history.totalUse": "การใช้งานทั้งหมด",
  "hems.history.fullScreen": "เต็มหน้าจอ",
  "hems.history.timeSelect": "เลือกวันที่",
  "sync.tips1": "ส่งคำสั่งซิงค์ข้อมูลสำเร็จ!",
  "sync.tips2": "กำลังซิงค์ข้อมูล เนื่องจากปริมาณข้อมูลมาก จึงต้องใช้เวลา โปรดตรวจสอบอีกครั้งหลังจากครึ่งชั่วโมง~",
  "sync.tips3": "การซิงค์ข้อมูลอุปกรณ์อาจมีความล่าช้า หากคุณพบความไม่สอดคล้องในข้อมูล โปรดคลิกที่:",
  "sync.tips4": "ซิงค์ข้อมูล",

  "charge.info": "ข้อมูลเครื่องชาร์จ",
  "news.loading": "กำลังโหลด...",
  "news.noMore": "ไม่มีข้อมูลเพิ่มเติม",
  "hems.pv.power": "ปริมาณพลังงานแสงแดด",

  // UEH specific
  "ueh.sellPower": "ปริมาณพลังงานที่ขายได้",
  
  "menu.home": "หน้าแรก",
  "menu.history": "ข้อมูลประวัติ",
  "menu.device": "อุปกรณ์",
  "menu.settings": "ตั้งค่า",
  "menu.messageCenter": "ศูนย์ข้อความ",
  "menu.help": "ช่วยเหลือและสนับสนุน",
  "menu.mine": "ส่วนตัวของฉัน",


  "mine.userSetting": "ตั้งค่าผู้ใช้",
  "mine.terminalSetting": "ตั้งค่าเบื้องต้นของเทอร์มินัล",
  "mine.uploadCloud": "อัปโหลดข้อมูลไปยังคลาวด์",
  "mine.changeVersion": "ตรวจสอบการอัปเดต",
  "mine.language": "เปลี่ยนภาษา",
  "mine.about": "เกี่ยวกับแอปพลิเคชัน",
  "mine.feedback": "ข้อเสนอแนะ",
  "mine.logout": "ออกจากระบบ",
  "mine.logoutAccount": "ลบบัญชี",

  "mine.logoutAccountTips": "ลบบัญชีชื่อ []",
  "mine.logoutAccountTips1": "ลบบัญชีที่เชื่อมโยงกับ []",
  "mine.logoutAccountCare": "คำแนะนำเกี่ยวกับการขอให้ลบบัญชี:",
  "mine.logoutAccountCare1": "1. บัญชีอยู่ในสถานะปลอดภัย",
  "mine.logoutAccountCare1-1": "บัญชีอยู่ในสถานะการใช้งานปกติ ไม่มีความเสี่ยงในการขโมย ละเมิดกฎหรือบล็อก",
  "mine.logoutAccountCare2": "2. การให้อัตโนมัติและการเชื่อมโยงของบัญชี已ถูกลบ",
  "mine.logoutAccountCare2-1": "การให้อัตโนมัติทั้งหมดของบัญชีกับแพลตฟอร์มของบุคคลที่สาม已ถูกลบ",
  "mine.logoutAccountCare3": "3. หลังจากลบบัญชีแล้วไม่สามารถกู้คืนได้ ข้อมูลผู้ใช้จะถูกลบ",
  "mine.logoutAccountCare3-1": "หลังจากลบบัญชีแล้ว เบอร์โทรศัพท์ อีเมล และข้อมูลอื่นๆ ที่เชื่อมโยงจะถูกลบและไม่สามารถกู้คืนได้",
  "mine.confirmLogout": "ยืนยันการลบ",
  "mine.logoutSuccess": "ลบบัญชีสำเร็จ!",


  "mine.feedbackIssues": "ข้อเสนอแนะเกี่ยวกับปัญหา",
  "mine.feedQuantity": "ปริมาณ",
  "mine.feedAmount": "สูงสุด 9 รูปภาพ ขนาดสูงสุด 1 MB/รูปภาพ",

  "mine.notice.fail": "ดึงข้อมูลตั้งค่าการแจ้งเตือนไม่สำเร็จ!",
  "mine.notice.saveSuccess": "บันทึกตั้งค่าการแจ้งเตือนสำเร็จ!",
  "mine.notice.saveFail": "บันทึกไม่สำเร็จ!",
  "mine.notice.title": "ตั้งค่าการแจ้งเตือน",
  "mine.notice.batteryLow": "แจ้งเตือนระดับแบตเตอรี่ต่ำ",
  "mine.notice.chargingFinish": "แจ้งเตือนการชาร์จเครื่องชาร์จเสร็จสิ้น",
  "mine.notice.error": "แจ้งเตือนข้อผิดพลาด",
  "mine.notice.update": "แจ้งเตือนการอัปเดต",
  "mine.notice.monthly": "แจ้งเตือนสถิติรายเดือน",
  "mine.notice.receiveType": "วิธีรับแจ้งเตือน",

  "mine.language.welcome": "ยินดีต้อนรับสู่ SusprSafe",
  "mine.language.desc1": "เลือเวอร์ชันภาษาตามที่อยู่อาศัยของคุณ",
  "mine.language.desc2": "คุณสามารถเปลี่ยนได้ทุกเวลาในตั้งค่าแอปพลิเคชัน",

  "mine.userInfo.avatar": "รูปโปรไฟล์",
  "mine.userInfo.nickname": "ชื่อเล่น",
  "mine.userInfo.password": "รหัสผ่าน",
  "mine.userInfo.changePassword": "เปลี่ยนรหัสผ่าน",
  "mine.userInfo.setPassword": "ตั้งรหัสผ่าน",
  "mine.userInfo.phoneNumber": "เบอร์โทรศัพท์",
  "mine.userInfo.bindPhone": "เชื่อมโยงเบอร์โทรศัพท์",
  "mine.userInfo.bindEmail": "เชื่อมโยงอีเมล",
  "mine.loginExpired": "สถานะการเข้าสู่ระบบหมดอายุ โปรดเข้าสู่ระบบอีกครั้ง",
  "mine.userInfo.title": "ข้อมูลผู้ใช้",
  "mine.userInfo.bind": "เชื่อมโยง",
  "mine.userInfo.modify": "แก้ไข",
  "mine.userInfo.modifyNickname": "เปลี่ยนชื่อเล่น",
  "mine.userInfo.userNickname": "ชื่อเล่นผู้ใช้",
  "mine.userInfo.selectPic": "เลือกรูปภาพเพื่ออัปโหลด",
  "mine.userInfo.saveSuccess": "บันทึกสำเร็จ",
  "mine.userInfo.uploadFail": "อัปโหลดไม่สำเร็จ",
  "mine.userInfo.avatarSaveSuccess": "บันทึกรูปโปรไฟล์สำเร็จ",
  "mine.userInfo.nameTips1": "ชื่อเล่นผู้ใช้ไม่สามารถเว้นว่างได้",
  "mine.userInfo.nameTips2": "ป้อนชื่อเล่นผู้ใช้",

  "common.pleaseSelect": "โปรดเลือก",
  "question.commonQuestions": "คำถามที่พบบ่อย",
  "account.toggleLanguage": "เปลี่ยนภาษา",
  "account.localConnection": "การเชื่อมต่อโลคัล",
  "account.selectLanguage": "โปรดเลือกภาษา",
  "account.sendEmailToast": "รหัสยืนยัน已ส่ง至อีเมล xxx โปรดตรวจสอบ",
  "account.emailError": "รูปแบบอีเมลไม่ถูกต้อง",
  "account.sendEmailFail": "ส่งไม่สำเร็จ โปรดลองอีกครั้ง",
  
  "common.submitting": "กำลังส่ง... โปรดรอ...",

  "device.page.noData": "ไม่มีข้อมูลในขณะนี้ หน้านี้สามารถดูได้ในแอปพลิเคชันเท่านั้น"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "อัปเกรด",
  "bmsFirmware.upgrading": "กำลังอัปเกรด...",
  "bmsFirmware.uploadingFile": "กำลังอัปโหลดไฟล์ firmware...",
  "bmsFirmware.upgradingProgress": "กำลังอัปเกรด firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "อัปเกรดสำเร็จ",
  "bmsFirmware.upgradeSuccessSubtitle": "อัปเกรด firmware BMS เสร็จสมบูรณ์!",
  "bmsFirmware.upgradeFailed": "อัปเกรดล้มเหลว",
  "bmsFirmware.upgradeFailedFormError": "โปรดตรวจสอบว่าการกรอกแบบฟอร์มถูกต้องหรือไม่",
  "bmsFirmware.upgradeFailedNetworkError": "เกิดข้อผิดพลาดเครือข่าย โปรดลองอีกครั้ง",
  "bmsFirmware.invalidFileType": "โปรดเลือกไฟล์ firmware ที่ถูกต้อง (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "โปรดเลือกไฟล์ firmware ก่อน",
  "bmsFirmware.statusUpgrading": "กำลังอัปเกรด",
  "bmsFirmware.statusCompleted": "อัปเกรดเสร็จสมบูรณ์",
  "bmsFirmware.statusFailed": "อัปเกรดล้มเหลว",
  "bmsFirmware.deviceUpgrading": "กำลังอัปเกรดแพ็คเกจ firmware ใช้เวลา 30-50 นาที ในช่วงนี้จะไม่สามารถดูข้อมูลอุปกรณ์แบบ real-time ได้ โปรดรอ...",
  "bmsFirmware.upgradeStatusLabel": "สถานะการอัปเกรด",
  "bmsFirmware.upgradeProgressLabel": "ความคืบหน้าการอัปเกรด",
  "bmsFirmware.currentPackageLabel": "หมายเลขแพ็คเกจข้อมูลปัจจุบัน",
  "bmsFirmware.totalPackagesLabel": "จำนวนแพ็คเกจข้อมูลทั้งหมด",
  "bmsFirmware.upgradeFailedCheckDevice": "โปรดตรวจสอบสถานะอุปกรณ์และลองอัปเกรดอีกครั้ง",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "ตั้งค่าสำเร็จ",
  "settingResult.defaultSubTitle": "บันทึกการตั้งค่าพารามิเตอร์แล้ว",
  "settingResult.confirmButton": "ตกลง"
};